import React from 'react';
import AppStore from '../stores/AppStore';
import TemplateData from '../utility/getTemplateData';
import { trackConfirmationPageIM } from '../fpti/fpti';

const PAGE_TRACK_TAG = 'main:donate:wps:';

export default function withPageTrack(WrappedComponent, flow, result) {
  return class extends React.Component {
    componentDidMount() {
      const confData = AppStore.getConfirmation() || {};
      let isGuestUpgrade = false;
      let updatedFlow = flow;
      let updatedResult = result;

      if (flow !== 'member') {
        isGuestUpgrade =
          confData.showAccountOverview ||
          confData.signUpSuccess ||
          TemplateData.fptPageName === 'guestULSignUp';

        if (TemplateData.onboardingEnabled) {
          updatedFlow = 'signup';
        }
      }

      if (isGuestUpgrade) {
        updatedResult = 'upgrade';
      }

      const tag = `${PAGE_TRACK_TAG}${updatedFlow}:${updatedResult}`;
      trackConfirmationPageIM({
        isSignUp: isGuestUpgrade,
        pageSpec: {
          pgrp: tag,
          page: `${tag}:web::`,
          tmpl: `${tag}:web::`,
        },
        flow,
        confirmationData: confData,
      });
    }

    render() {
      return <WrappedComponent {...this.props} />;
    }
  };
}
